import React from 'react';
import block from 'bem-cn';
import Spinner from 'components/Spinner/view/desktop';
import Button from 'components/Button';
import SVG from 'components/SVG';

import FilterBlock from './FilterBlock';
import Table from './Table/Table';

import usePromotions from 'features/bonusProgram/model/usePromotions/usePromotions';

import './Promotions.scss';

const b = block('promotions');

const Promotions = () => {
  const model = usePromotions();

  return (
    <div className={b()}>
      <div className={b('content')}>
        <Spinner isLoading={model.actionProcessing} />

        <FilterBlock model={model} />

        <Table
          currentPage={model.page}
          onPageClick={model.setPage}
          onItemsOnPageChanged={model.onItemsOnPageChanged}
          handleDeletePromotion={model.handleDeletePromotion}
        />
      </div>
    </div>
  );
};

export default Promotions;
